import { gql } from '@apollo/client';

// Note: GetCustomerDetails uses [UseSingleOrDefault] which returns a single CustomerLogin object
// directly, not wrapped in nodes array
export const GET_CUSTOMER_DETAILS = gql`
  query GetCustomerDetails {
    customerDetails {
      id
      cognitoUserId
      userName
      email
      firstName
      lastName
      stripeCustomerId
      status {
        statusName
      }
      customer {
        id
        companyName
        address1
        address2
        city
        state
        zip
        phone
        website
        testCustomer
        localPlus
        customerType {
          typeName
        }
        industry {
          typeName
        }
        numberofEmployee {
          typeName
        }
        createdDate
      }
    }
  }
`;

